<template>
  <v-container>
    <h1>Donation purposes</h1>
    <v-progress-linear v-if="loading" indeterminate />
    <v-alert v-if="error" type="error" variant="tonal">{{ error }}</v-alert>
    <v-row justify="start">
      <v-col
        v-for="initiative in options?.initiatives"
        :key="initiative.initiativeId"
      >
        <DonationInitiativeCard :donation-initiative="initiative" />
      </v-col>
    </v-row>
    <v-row justify="start">
      <v-col
        v-for="fund in options?.funds.filter((fund) => fund.showInCheckout)"
        :key="fund.fundId"
      >
        <DonationFundCard :donation-fund="fund" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script lang="ts" setup>
import {
  useDonationNew,
  type DonationOptions,
} from "@/composables/donations/useDonationNew";
const donations = useDonationNew();
const options = ref<DonationOptions>();
const loading = ref(true);
const error = ref("");
onMounted(async () => {
  try {
    options.value = await donations.fetchDonationOptions();
  } catch (cause) {
    error.value =
      cause instanceof Error
        ? cause.message
        : "Unable to load donation purposes.";
  } finally {
    loading.value = false;
  }
});
</script>
